import axios from "axios";
import Vue from "vue";

const headers = {
    "Content-Type": "multipart/form-data",
    // Accept: "application/json",
    // "Content-Type": "application/json",
    // Accept: "application/json",
    'Accept-Language': 'fa',
    Authorization: localStorage.getItem("token")
};
const API_V1 = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: headers
});

API_V1.interceptors.response.use(
    response => {
        return response;
    },
    async function (error) {
        Vue.$toast.error(error)
        if (error.request?.status === 401) {
            localStorage.removeItem("token")
            window.location.href = "/login";
        }

        if (error.request?.status >= 500) {
            this.$toast.error('خطایی رخ داده است')
        }

        return Promise.reject(error.response);
    },
);

export { API_V1 };
